import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nosotros',
  templateUrl: './nosotros.component.html',
  styleUrls: ['./nosotros.component.scss']
})
export class NosotrosComponent implements OnInit {

  @Input()
  ngStyle: { [klass: string]: any; };

  equipo: any[] = [
    {
      nombre: 'Andrés Hernandez', cargo: 'CEO/CFO',
      linked: 'https://www.linkedin.com/in/andres-hernandez-156108167/',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Andres2.JPG', color: '#f58b1f'
    },
    {
      nombre: 'Arley Patiño', cargo: 'Coord. Crecimiento',
      linked: 'https://www.linkedin.com/in/arley-pati%C3%B1o-uribe-a38b03188/',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Arley2.JPG', color: '#47d147'
    },
    {
      nombre: 'Alejandra Amaya', cargo: 'Coord. Logistica',
      linked: 'https://www.linkedin.com/in/alejandra-amaya-grisales-67587169/',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Aleja2.JPG', color: '#ff4d4d'
    },
    {
      nombre: 'Paulo Velásquez', cargo: 'Coord. Producto',
      linked: 'https://www.linkedin.com/in/paulo-cesar-velasquez-sierra-6331571b7',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Paulo2.JPG', color: '#4d4dff'
    },
    {
      nombre: 'Debora Barrientos', cargo: 'Servicio al Cliente',
      linked: 'https://www.linkedin.com/in/debora-barrientos-arroyave-968aa81b7/',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Debora2.JPG', color: '#e6e600'
    },
    {
      nombre: 'Liz Cano', cargo: 'Analista Contable',
      linked: '', foto: '../../assets/images/Nosotros/Fotos/LIZ.jpg', color: '#ff4dff'
    },
    {
      nombre: 'Jorge Aranzazu', cargo: 'Manager Ventas',
      linked: 'https://www.linkedin.com/in/jorge-aranzazu-3a4241190',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Jorge2.JPG', color: '#47d147'
    },
    {
      nombre: 'Esteban Suárez', cargo: 'Productor Audiovisual',
      linked: 'https://www.linkedin.com/in/esteban-suarez-a92b121b7/',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Esteban2.JPG', color: '#47d147'
    },
    {
      nombre: 'Omar Estevez', cargo: 'Desarrollador Front',
      linked: 'https://www.linkedin.com/in/estevezn-omar',
      foto: '../../assets/images/Nosotros/Fotos/Omar.jpg', color: '#4d4dff'
    },
    {
      nombre: 'Paola Ostos', cargo: 'Aux. Logistico',
      linked: 'https://www.linkedin.com/in/paola-ostos-a34ba81b6/',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Paola.jpeg', color: '#ff4d4d'
    },
    {
      nombre: 'Gabriel Arroyave', cargo: 'Aux. Logistico',
      linked: 'https://www.linkedin.com/in/gabriel-arroyave-61bbaa1b6/',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Gabriel.jpeg', color: '#ff4d4d'
    },
    {
      nombre: 'Juan Hernández', cargo: 'Aux. Logistico',
      linked: 'https://www.linkedin.com/in/juan-david-hernandez-landinez-b662121b9/',
      foto: '../../assets/images/Nosotros/Fotos/Juan David.jpg', color: '#ff4d4d'
    },
    {
      nombre: 'Claudia Cubides', cargo: 'Asesora Serv. Cliente',
      linked: '', foto: '../../assets/images/Nosotros/Fotos/Claudia.jpg', color: '#e6e600'
    },
    {
      nombre: 'Saray Restrepo', cargo: 'Asesora Serv. Cliente',
      linked: 'https://www.linkedin.com/in/saray-restrepo-5b043b1b8/',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Saray.jpg', color: '#e6e600'
    },
    {
      nombre: 'Anderson Marín', cargo: 'Asesor Serv. Cliente',
      linked: 'https://www.linkedin.com/in/john-anderson-marin-cossio-89abaa1b6',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Anderson2.JPG', color: '#e6e600'
    },
    {
      nombre: 'Cristian Guzman', cargo: 'Asesor Serv. Cliente',
      linked: 'linkedin.com/in/cristian-guzman-8b40021ab',
      foto: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Cristian2.JPG', color: '#e6e600'
    }];

  constructor() { }

  ngOnInit(): void {
  }

}
